angular.module('zc.projects')

.directive 'zcParticularEventEditor', (ProjectParticularEvent, Meta, BaseProjectCrudEditor) ->

  class ParticularEventEditor extends BaseProjectCrudEditor
    link: (scope, element, attrs) ->
      # only this specific functionality
      scope.particularEventPageTypes = []
      scope.particularEventNames = []

      Meta.getParticularEventPageTypes().then (res) ->
        scope.particularEventPageTypes = res

      Meta.getParticularEventNames().then (res) ->
        scope.particularEventNames = res

  editor = new ParticularEventEditor(
    ProjectParticularEvent
    Meta
    '/templates/projects.settings/other/particular_event_editor.html'
  )

  return editor.createDirective()




// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.settings/other/particular_event_editor.directive.coffee